module.exports = __webpack_public_path__ + "assets/webgl/art_083_L0.jpg.astc.354c8bc6.ktx";